module.exports = __webpack_public_path__ + "img/vue.c3182097.svg";